var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticClass: "pb-6",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-lg-space-between",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-inline-flex"
                            },
                            [
                              _vm._v(" Site Information "),
                              _vm.info_collapsed
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-3",
                                      attrs: {
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v(" mdi-checkbox-marked-circle ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm.info_collapsed
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        "x-small": ""
                                      },
                                      on: {
                                        click: function click($event) {
                                          _vm.info_collapsed = false
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "primary"
                                          }
                                        },
                                        [_vm._v(" mdi-pencil ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _vm.info_collapsed
                            ? _c("span", [
                                _vm._v(
                                  "Your website will be installed on " +
                                    _vm._s(_vm.websiteName)
                                )
                              ])
                            : _c("span", [
                                _vm._v(" If you change your mind, you may "),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.setStep(1)
                                      }
                                    }
                                  },
                                  [_vm._v(" go back ")]
                                ),
                                _vm._v(" and select a different option. ")
                              ])
                        ]
                      )
                    ],
                    1
                  ),
                  !_vm.info_collapsed
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-form",
                                [
                                  _c("gg-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Site / Project name",
                                      name: "project-name",
                                      outlined: "",
                                      autocomplete: "new-password",
                                      "data-vv-as": "Site / Project name",
                                      "error-messages": _vm.errors.collect(
                                        "project-name"
                                      )
                                    },
                                    model: {
                                      value: _vm.siteName,
                                      callback: function callback($$v) {
                                        _vm.siteName = $$v
                                      },
                                      expression: "siteName"
                                    }
                                  }),
                                  _c("gg-text-field", {
                                    attrs: {
                                      label: "Site Description",
                                      name: "site-description",
                                      outlined: "",
                                      autocomplete: "new-password",
                                      "data-vv-as": "Site Description",
                                      "error-messages": _vm.errors.collect(
                                        "site-description"
                                      )
                                    },
                                    model: {
                                      value: _vm.siteDescription,
                                      callback: function callback($$v) {
                                        _vm.siteDescription = $$v
                                      },
                                      expression: "siteDescription"
                                    }
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              label: "Protocol",
                                              name: "protocol",
                                              disabled: "",
                                              outlined: "",
                                              autocomplete: "new-password",
                                              "data-vv-as": "Protocol",
                                              "error-messages": _vm.errors.collect(
                                                "protocol"
                                              )
                                            },
                                            model: {
                                              value: _vm.protocol,
                                              callback: function callback($$v) {
                                                _vm.protocol = $$v
                                              },
                                              expression: "protocol"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          !_vm.isModeManual
                                            ? _c("gg-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  value: _vm.service,
                                                  label: "Domain",
                                                  name: "domain",
                                                  disabled: "",
                                                  outlined: "",
                                                  autocomplete: "new-password",
                                                  "data-vv-as": "Domain",
                                                  "error-messages": _vm.errors.collect(
                                                    "domain"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.domain,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.domain = $$v
                                                  },
                                                  expression: "domain"
                                                }
                                              })
                                            : _c("gg-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  items:
                                                    _vm.second_step.domains,
                                                  label: "Domain",
                                                  name: "domain",
                                                  outlined: "",
                                                  autocomplete: "new-password",
                                                  "data-vv-as": "Domain",
                                                  "error-messages": _vm.errors.collect(
                                                    "domain"
                                                  )
                                                },
                                                on: {
                                                  input: _vm.toggleDomain
                                                },
                                                model: {
                                                  value: _vm.domain,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.domain = $$v
                                                  },
                                                  expression: "domain"
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          staticClass: "py-6",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-lg-space-between",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-inline-flex"
                            },
                            [
                              _vm._v(" SSL Configuration "),
                              _vm.ssl || _vm.domainHasSSL
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-3",
                                      attrs: {
                                        color: "primary",
                                        small: ""
                                      }
                                    },
                                    [_vm._v(" mdi-checkbox-marked-circle ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm.ssl_collapsed
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        "x-small": ""
                                      },
                                      on: {
                                        click: function click($event) {
                                          _vm.ssl_collapsed = false
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "primary"
                                          }
                                        },
                                        [_vm._v(" mdi-pencil ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _vm.ssl_collapsed
                    ? _c(
                        "v-row",
                        [
                          _vm.domainHasSSL
                            ? _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Your website " +
                                      _vm._s(_vm.websiteName) +
                                      " will be secured with an SSL certificate. "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "v-row",
                        [
                          _vm.domainHasSSL
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "primary--text body-1 mb-0"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mb-1",
                                          attrs: {
                                            size: "20",
                                            color: "primary"
                                          }
                                        },
                                        [_vm._v("mdi-check-circle")]
                                      ),
                                      _vm._v(
                                        " Excellent, SSL is already enabled "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "v-switch",
                                    {
                                      staticClass: "mt-0",
                                      attrs: {
                                        label: "Enable SSL"
                                      },
                                      on: {
                                        change: _vm.toggleSslSwitch
                                      },
                                      model: {
                                        value: _vm.ssl,
                                        callback: function callback($$v) {
                                          _vm.ssl = $$v
                                        },
                                        expression: "ssl"
                                      }
                                    },
                                    [_vm._v(" Enable SSL ")]
                                  ),
                                  _vm.ssl
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "mb-0"
                                        },
                                        [
                                          _vm._v(
                                            " A Let’s Encrypt SSL certificate will be deployed with your website. "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.second_step.themes.length,
              expression: "second_step.themes.length"
            }
          ],
          staticClass: "py-6",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Pick a Theme ")]),
              _c(
                "gg-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _vm._v(
                            " Select a theme to use for your website. If you do not select a theme, the default WordPress theme will be used. You can always change this later. "
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("data-view", {
                            attrs: {
                              cols: "3",
                              items: _vm.second_step.themes,
                              "initial-value": _vm.theme,
                              mandatory: true,
                              theme: ""
                            },
                            model: {
                              value: _vm.theme,
                              callback: function callback($$v) {
                                _vm.theme = $$v
                              },
                              expression: "theme"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.second_step.plugins.length,
              expression: "second_step.plugins.length"
            }
          ],
          staticClass: "py-6",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Select Plugins ")]),
              _c(
                "gg-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _vm._v(
                            " Plugins add additional capability to your website. You can install plugins later if you aren’t sure yet. "
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("data-view", {
                            attrs: {
                              cols: "3",
                              items: _vm.second_step.plugins,
                              "initial-value": _vm.plugins,
                              "plugins-dialog": "",
                              multiple: "",
                              svg: false
                            },
                            model: {
                              value: _vm.plugins,
                              callback: function callback($$v) {
                                _vm.plugins = $$v
                              },
                              expression: "plugins"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          staticClass: "py-6",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _vm._v(" Powered by LiteSpeed & LSCache "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-3",
                      attrs: {
                        color: "primary",
                        small: ""
                      }
                    },
                    [_vm._v("mdi-checkbox-marked-circle")]
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", {
                        staticClass: "pb-0",
                        attrs: {
                          cols: "12"
                        }
                      }),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "8"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2"
                            },
                            [
                              _vm._v(
                                " GreenGeeks websites run on LiteSpeed servers, so you can take full advantage of the LiteSpeed Cache website acceleration plugin. With advanced cache-management tools and optimization features. LSCache for WordPress is an all-in-one site acceleration solution. It's the only optimization plugin you need! "
                              )
                            ]
                          ),
                          _c("p", [
                            _vm._v(
                              " Caching via LiteSpeed is activated by default so your site can employ the best practices that make for a high PageSpeed score, and more importantly an incredible user experience . You can disable this at any time from within your WP Dashboard. "
                            )
                          ]),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-clipboard-arrow-down-outline")]
                                  ),
                                  _vm._v(" Server-Level Full-Page Cache ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-lock")]
                                  ),
                                  _vm._v(" Private Cache ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "mdi-checkbox-blank-circle-outline"
                                      )
                                    ]
                                  ),
                                  _vm._v(" Edge Side Includes (ESI) ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-image-size-select-actual")]
                                  ),
                                  _vm._v(" Image Optimization ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-cogs")]
                                  ),
                                  _vm._v(" Crawler ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-arrow-collapse-vertical")]
                                  ),
                                  _vm._v(" CSS/JavaScript/HTML Minify ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-folder-outline")]
                                  ),
                                  _vm._v(" CSS/JavaScript Combination ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-telegram")]
                                  ),
                                  _vm._v(" HTTP/2 Push ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-cloud-download")]
                                  ),
                                  _vm._v(" Content Delivery Network Support ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-file-code-outline")]
                                  ),
                                  _vm._v(" Browser Cache Support ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-image-frame")]
                                  ),
                                  _vm._v(" Lazy Load Images ")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        medium: "",
                                        color: "primary"
                                      }
                                    },
                                    [_vm._v("mdi-database")]
                                  ),
                                  _vm._v(" Database Optimization ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-auto",
                          attrs: {
                            cols: "12",
                            md: "4"
                          }
                        },
                        [
                          _c("v-img", {
                            staticClass: "d-flex align-center ma-auto",
                            attrs: {
                              src: "/static/img/wizard/litespeed-logo.png",
                              height: "280",
                              width: "280"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c("gg-error", {
                attrs: {
                  data: this.errors.all()
                }
              }),
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: "",
                        tile: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.setStep(1)
                        }
                      }
                    },
                    [_vm._v(" Back ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mx-1",
                      attrs: {
                        color: "primary",
                        tile: "",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.submit
                      }
                    },
                    [_vm._v(" Create My website ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }